/* A simple and scalable hamburger menu using css transitions. */
var isActive = false;

$('.js-menu').on('click', function () {
    if (isActive) {
        $(this).removeClass('active');
        $('body').removeClass('menu2');
        $('body').removeClass('menu-open');
        $('body').removeClass('project-title-open');
    } else {
        $(this).addClass('active');
        $('body').addClass('menu2');
        $('body').addClass('menu-open');
        $('body').addClass('project-title-open');
        $('.projectMenu').removeClass('inactive');
    }

    isActive = !isActive;
});

$('.js-menu').addClass('active');
$('body').addClass('menu2');
$('body').addClass('menu-open');
$('body').addClass('project-title-open');
setTimeout(()=>{
    $('.js-menu').removeClass('active');
    $('.projectMenu').removeClass('inactive');
    $('body').removeClass('menu2');
    $('body').removeClass('menu-open');
    $('body').removeClass('project-title-open');
}, 3000)